const StatusSummaryCard = ({ title, color, items = [] }) => {
  const totalQty = items.reduce((sum, i) => sum + i.qty, 0);
  const totalPrice = items.reduce((sum, i) => sum + i.price, 0);

  if (!items.length) {
    return (
      <div className={`border-l-4 ${color} bg-gray-50 rounded-md p-4`}>
        <h4 className="font-bold mb-2">{title}</h4>
        <p className="text-sm text-gray-500">لا توجد بيانات</p>
      </div>
    );
  }

  return (
    <div className={`border-l-4 ${color} bg-white shadow-sm rounded-md p-4`}>
      <h4 className="font-bold mb-2">{title}</h4>

      <div className="text-sm text-gray-700">
        <p>🧾 عدد القطع: <strong>{totalQty}</strong></p>
        <p>💰 الإجمالي: <strong>{totalPrice} جنيه</strong></p>
      </div>

      <div className="mt-2 text-xs text-gray-500">
        {items.slice(0, 5).map((i, idx) => (
          <span key={idx} className="inline-block mr-2">
            • {i.name} ({i.qty})
          </span>
        ))}
        {items.length > 5 && <span>...</span>}
      </div>
    </div>
  );
};

export default StatusSummaryCard;
